import { Tree, Modal } from "antd";
const TreeNode = Tree.TreeNode;
import isArray from "lodash/isArray";
import WeaDialog from "../../wea-dialog";
import WeaTools from "../../wea-tools";
import WeaLocaleProvider from "../../wea-locale-provider";

const getLabel = WeaLocaleProvider.getLabel;

let that = {};

export default class WeaTreeHr extends React.Component {
  constructor(props) {
    super(props);
    const {
      prefix,
      topPrefix,
      dataKey,
      isMult,
      ids,
      names,
      defaultExpandedKeys
    } = props;
    let idArr = ids ? ids.split(",") : [];
    let nameArr = names ? names.split(",") : [];
    for (let i = 0; i < idArr.length; i++) {
      idArr[i] = prefix + idArr[i];
    }
    this.state = {
      treeData: [],
      prefix: prefix,
      dataKey: dataKey,
      topPrefix: topPrefix,
      isMult: isMult,
      ids: idArr,
      names: nameArr,
      expandedKeys: defaultExpandedKeys,
      defaultExpandedKeys: defaultExpandedKeys,
      hasRight: 0, // 是否有常用组的编辑权限
      visible: false,
      groupId: "",
      isCreate: true,
      groupType: 0, // 新建类型：0私人组 1公共组
      adviceVisible: false // 公共组调整建议弹框
    };
    that = this;
  }
  componentDidMount() {
    const { treeData } = this.props;
    generateData(treeData.datas);
    this.setState({
      treeData: objToArray(treeData.datas),
      hasRight: treeData.hasRight || 0
    });
  }
  componentWillReceiveProps(nextProps) {
    const { treeData, defaultExpandedKeys } = this.props;
    if (treeData !== nextProps.treeData) {
      generateData(nextProps.treeData.datas);
      this.setState({
        expandedKeys: nextProps.defaultExpandedKeys,
        treeData: objToArray(nextProps.treeData.datas),
        hasRight: nextProps.treeData.hasRight || 0
      });
    }
    if (defaultExpandedKeys !== nextProps.defaultExpandedKeys) {
      this.setState({ expandedKeys: nextProps.defaultExpandedKeys });
    }
  }

  onSelect(info, e) {
    const nodes = e.selectedNodes;
    const eventKey = e.node.props.eventKey;
    this.setTheDatas(nodes, eventKey);
  }
  onExpandChange(expandedKeys, nodeObj) {
    this.setState({ expandedKeys: expandedKeys });
  }
  setTheDatas(nodes, key) {
    let idArr = [];
    let nameArr = [];
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i].props;
      if (key.indexOf("resource") > -1) {
        idArr.push(node.id);
        nameArr.push(node.lastname);
      }
    }
    let newIdArr = [];
    let newNameArr = [];
    jQuery.each(idArr, function(i, el) {
      if (jQuery.inArray(el, newIdArr) === -1) newIdArr.push(el);
    });
    jQuery.each(nameArr, function(i, el) {
      if (jQuery.inArray(el, newNameArr) === -1) newNameArr.push(el);
    });

    let ids = newIdArr.join(",");
    let names = newNameArr.join(",");
    key.indexOf("resource") > -1 &&
      this.props.setData &&
      this.props.setData(ids, names);
  }
  onLoadData = treeNode => {
    let _this = this;
    const { dataUrl, isAccount, virtualtype } = this.props;
    const { treeKey, id, type } = treeNode.props;
    const params = {
      type: type,
      id: id
    };
    if (isAccount) params["isNoAccount"] = 1;
    if (virtualtype) params["virtualtype"] = virtualtype;
    return new Promise(resolve => {
      WeaTools.callApi(dataUrl, "GET", params)
        .then(datas => {
          const treeData = [..._this.state.treeData];
          getNewTreeData(
            treeData,
            treeKey,
            generateTreeNodes(datas, treeNode),
            3
          );
          _this.setState({ treeData });
          resolve();
        })
        .catch(e => this.props.onError && this.props.onError(e));
    });
  };

  onAdd = (e, item) => {
    this.stopPropagation(e);
    this.setState(
      {
        isCreate: true,
        groupId: "",
        groupType: item.isPrivate === "true" ? 0 : 1
      },
      () => {
        this.setState({ visible: true });
      }
    );
  };

  onEdit = (e, item) => {
    this.stopPropagation(e);
    this.setState({ isCreate: false, groupId: item.id }, () => {
      this.setState({ visible: true });
    });
  };

  onDelete = (e, item) => {
    const { dataParams = {} } = this.props;
    this.stopPropagation(e);
    Modal.confirm({
      title: getLabel(131329, "信息确认"),
      content: getLabel(385625, "确定要删除选择的记录吗？"),
      onOk: () => {
        WeaTools.callApi("/api/hrm/group/delete", "POST", {
          cmd: "base",
          groupid: item.id,
          f_weaver_belongto_userid: dataParams.f_weaver_belongto_userid || ""
        })
          .then(res => {
            if (res.status === "1") {
              const { getGrouptree } = this.props;
              getGrouptree && getGrouptree();
            }
          })
          .catch(e => this.props.onError && this.props.onError(e));
      }
    });
  };

  onAdvice = (e, item) => {
    this.stopPropagation(e);
    this.setState({ groupId: item.id }, () => {
      this.setState({ adviceVisible: true });
    });
  };

  onCancel = () => {
    this.setState({
      visible: false,
      isCreate: true,
      groupId: "",
      groupType: 0
    });
  };

  callback = type => {
    const { getGrouptree } = this.props;
    this.setState({ updateExpandKeys: false });
    if (type === 0) {
      // 新建保存 -- 刷新常用组
      this.setState({ visible: false, isCreate: true, groupId: "" });
    }
    if (type === 1) {
      // 保存并进入详细设置
      this.setState({ isCreate: false });
    }
    getGrouptree && getGrouptree();
  };

  stopPropagation = e => {
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
  };

  render() {
    const {
      isMult,
      ids,
      defaultExpandedKeys,
      expandedKeys,
      visible,
      groupId,
      isCreate,
      hasRight,
      groupType,
      adviceVisible
    } = this.state;
    const { icon, iconBgcolor, dataParams = {} } = this.props;
    // 常用组的URL
    const fId = dataParams.f_weaver_belongto_userid || "";
    const createGroupUrl =
      fId !== ""
        ? `/spa/hrm/index_mobx.html#/main/hrm/operateGroup?groupType=${groupType}&f_weaver_belongto_userid=${fId}`
        : `/spa/hrm/index_mobx.html#/main/hrm/operateGroup?groupType=${groupType}`;
    const editGroupUrl =
      fId !== ""
        ? `/spa/hrm/index_mobx.html#/main/hrm/operateGroup?groupId=${groupId}&f_weaver_belongto_userid=${fId}`
        : `/spa/hrm/index_mobx.html#/main/hrm/operateGroup?groupId=${groupId}`;
    const groupUrl = isCreate ? createGroupUrl : editGroupUrl;

    const loop = data =>
      data.map(item => {
        let title = null;
        // add: !item.pid存在 父节点 && (私人组 || 有权限的公共组  (isPrivate并不是都有这个参数))
        // edit: item.pid 子节点 && (私人组 || 有权限的公共组)
        // advice: item.pid 子节点 && 没有权限的公共组（可以提交调整公共组建议）
        const canAdd =
          !item.pid &&
          (item.isPrivate === "true" ||
            (item.isPrivate === "false" && hasRight === 1));
        let canEdit = false;
        if (item.canEdit) {
          canEdit =
            item.pid &&
            (item.isPrivate === "true" ||
              (item.isPrivate === "false" && item.canEdit === "true"));
        } else {
          canEdit =
            item.pid &&
            (item.isPrivate === "true" ||
              (item.isPrivate === "false" && hasRight === 1));
        }
        const canAdvice =
          item.pid && item.isPrivate === "false" && hasRight !== 1;
        if (item.type == "com") {
          title = (
            <div>
              {typeof icon === "string" ? <span className={icon} /> : icon}
              {item.lastname}
              <span className="wea-f12" style={{ color: "#979797" }}>
                {/*人数占位*/}
              </span>
            </div>
          );
        } else if (item.type == "subcom") {
          title = (
            <div>
              <i className="icon-process-scene" />
              {item.lastname}
            </div>
          );
        } else if (item.type == "dept") {
          title = (
            <div>
              <i className="icon-mail-folder" /> {item.lastname}
            </div>
          );
        } else if (item.type == "resource") {
          title = (
            <div className="wea-f12">
              <img className="wea-tree-hr-portrait" src={item.icon} alt="img" />
              <span style={{ paddingLeft: 10 }}>{item.lastname}</span>
              <span style={{ color: "#929390", paddingLeft: 10 }}>
                {item.jobtitlename}
              </span>
            </div>
          );
        } else {
          title = (
            <div>
              <i className={item.cusIcon || "icon-process-scene"} />
              {item.cusIcon ? (
                <span style={{ paddingLeft: 10 }}>{item.lastname}</span>
              ) : (
                item.lastname
              )}
              <span className="wea-tree-hr-node">
                {canAdd && (
                  <span
                    className="wea-tree-hr-node-icon"
                    title={getLabel("611", "添加")}
                    onClick={e => this.onAdd(e, item)}
                  >
                    <i className="icon-coms-Add-to" />
                  </span>
                )}
                {canEdit && (
                  <span
                    className="wea-tree-hr-node-icon"
                    title={getLabel("26473", "编辑")}
                    onClick={e => this.onEdit(e, item)}
                  >
                    <i className="icon-coms-edit" />
                  </span>
                )}
                {canEdit && (
                  <span
                    className="wea-tree-hr-node-icon"
                    title={getLabel(91, "删除")}
                    onClick={e => this.onDelete(e, item)}
                  >
                    <i className="icon-coms-delete" />
                  </span>
                )}
                {canAdvice && (
                  <span
                    className="wea-tree-hr-node-icon"
                    title={getLabel(16159, "建议")}
                    onClick={e => this.onAdvice(e, item)}
                  >
                    <i className="icon-coms-Advice" />
                  </span>
                )}
              </span>
            </div>
          );
        }

        if (item.children && item.children.length > 0) {
          for (let i = 0; i < item.children.length; i++) {
            item.children[
              i
            ].treeKey = `${item.treeKey}-${item.children[i].nodeid}`;
          }
          return (
            <TreeNode
              title={title}
              lastname={item.lastname}
              jobtitlename={item.jobtitlename}
              key={item.treeKey}
              id={item.id}
              treeKey={item.treeKey}
              isLeaf={item.isLeaf}
              type={item.type}
            >
              {loop(item.children)}
            </TreeNode>
          );
        }
        return (
          <TreeNode
            title={title}
            lastname={item.lastname}
            jobtitlename={item.jobtitlename}
            key={item.treeKey}
            id={item.id}
            treeKey={item.treeKey}
            isLeaf={item.isLeaf}
            type={item.type}
          />
        );
      });
    const treeNodes = loop(this.state.treeData);
    return (
      <div className="wea-tree-hr">
        <Tree
          className="my-Tree"
          clickNodeExpandChildren={!isMult}
          defaultExpandedKeys={defaultExpandedKeys}
          expandedKeys={expandedKeys}
          onSelect={this.onSelect.bind(this)}
          loadData={this.onLoadData.bind(this)}
          checkable={isMult}
          multiple={isMult}
          selectedKeys={ids}
          checkedKeys={ids}
          needExpandChildren
          onExpand={this.onExpandChange.bind(this)}
        >
          {treeNodes}
        </Tree>
        {visible && ( // 新建 编辑常用组弹框
          <WeaDialog
            title={
              isCreate
                ? getLabel("386496", "新建常用组")
                : getLabel("126252", "常用组设置")
            }
            style={
              isCreate
                ? { width: 650, height: 225 }
                : { width: 750, height: 482 }
            }
            icon={icon}
            iconBgcolor={iconBgcolor}
            visible={visible}
            url={groupUrl}
            onCancel={this.onCancel}
            callback={this.callback}
          />
        )}
        {adviceVisible && ( // 公共组调整建议弹框
          <WeaDialog
            title={getLabel("126253", "公共组调整建议")}
            style={{ width: 650, height: 360 }}
            icon={icon}
            iconBgcolor={iconBgcolor}
            visible={adviceVisible}
            url={`/spa/hrm/static/index.html#/main/hrm/groupAdvice?groupId=${groupId}`}
            onCancel={() => this.setState({ adviceVisible: false })}
            callback={() => this.setState({ adviceVisible: false })}
          />
        )}
      </div>
    );
  }
}

function objToArray(obj) {
  if (!isArray(obj)) {
    let arr = [];
    arr.push(obj);
    obj = arr;
  }
  return obj;
}

function generateData(data, level = 1) {
  const { topPrefix } = that.state;
  if (!isArray(data)) {
    data.isLeaf = data.isParent === "false";
    if (level == 1) data.treeKey = `${topPrefix}0-${data.nodeid}`;
    if (data.children && data.children.length > 0)
      generateData(data.children, level + 1);
  } else {
    data.forEach(item => {
      if (level == 1) item.isLeaf = item.isParent === "false";
      if (item.children && item.children.length > 0)
        generateData(item.children, level + 1);
    });
  }
}

function generateTreeNodes(data, treeNode) {
  let arr = new Array();
  const { topPrefix } = that.state;
  if (!treeNode) {
    arr.push({
      id: data.id,
      lastname: data.lastname,
      nodeid: data.nodeid,
      jobtitlename: data.jobtitlename,
      treeKey: `${topPrefix}0-${data.nodeid}`,
      icon: data.icon,
      isLeaf: !data.isParent || data.isParent === "false", //isLeaf:data.children.length === 0,
      children: data.children,
      open: data.open,
      type: data.type
    });
  } else {
    const loop = datas => {
      for (let i = 0; i < datas.length; i++) {
        const data = datas[i];
        const { treeKey, id } = treeNode.props;
        arr.push({
          id: data.id,
          lastname: data.lastname,
          nodeid: data.nodeid,
          jobtitlename: data.jobtitlename,
          treeKey: `${treeKey}-${data.nodeid}`,
          icon: data.icon,
          isLeaf: !data.isParent || data.isParent === "false", //isLeaf:data.children.length === 0,
          children: data.children,
          open: data.open,
          type: data.type
        });
      }
    };
    loop(data.datas);
  }
  return arr;
}

function getNewTreeData(treeData, curKey, child, level) {
  let hrData = new Array();
  const findData = data =>
    data.forEach(item => {
      if (item.children && !!item.open) {
        findData(item.children);
      } else if (!item.open) {
        hrData.push(item);
      }
    });
  findData(treeData);

  const loop = data => {
    data.forEach(item => {
      if ((curKey + "-").indexOf(item.treeKey + "-") === 0) {
        if (item.children && item.children.length > 0) {
          loop(item.children);
        } else {
          item.children = child;
        }
      } else {
      }
    });
  };

  loop(hrData);
}



// WEBPACK FOOTER //
// ./ecology9/base/wea-tree-hr/index.js